import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Instructor } from 'src/app/model/instructor.model';
import { MatDialog } from '@angular/material/dialog';
import { InstructorService } from 'src/app/service/instructor.service';
import { Router } from '@angular/router';
import { DeleteConfirmationDialog } from '../../delete-confirmation/delete-confirmation.dialog';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-instructor-detail',
  templateUrl: './instructor-detail.component.html',
  styleUrls: ['./instructor-detail.component.css']
})
export class InstructorDetailComponent implements OnInit {
  @Input() instructor: Instructor;
  @Output() instructorDeleted: EventEmitter<any> = new EventEmitter();

  constructor(public dialog: MatDialog, private instructorService: InstructorService, private router: Router, private datePipe: DatePipe) {}

  ngOnInit() {}

  instructorSchedule(instructor: Instructor) {
    this.router.navigateByUrl(`/schedule-instructor/${instructor.user.id}`);
  }

  editInstructor(instructor: Instructor) {
    this.router.navigateByUrl(`/instructor-edit/${instructor.user.id}`);
  }

  deleteInstructor() {
    const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
      width: '300px',
      data: {
        title: `DELETE ${this.instructor.user.name} ${this.instructor.user.lastName}`,
        message: 'Enter instructor name to confirm delete',
        key: this.instructor.user.name,
        enterKeyToConfirm: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.instructorService.delete(this.instructor.user.id).subscribe(data => {
          this.instructorDeleted.emit();
        });
      }
    });
  }
}
